import React, { FC } from 'react';
import styles from './ProfileData.module.css';

/**
 * Renders information about the user obtained from MS Graph
 * @param props 
 */
export const ProfileData = (props: { graphData: { givenName: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactFragment | React.ReactPortal | null | undefined; surname: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactFragment | React.ReactPortal | null | undefined; userPrincipalName: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactFragment | React.ReactPortal | null | undefined; id: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactFragment | React.ReactPortal | null | undefined; }; }) => {
    return (
        <div id="profile-div">
            
        </div>
    );
};